export const WA_NUMBER = "5513997881908";

export const wa = (msg) =>
    `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export const MSG = {
    consulta:
        "Olá! Acessei o site do Dr. Gabriel Riccio e gostaria de obter informações sobre uma consulta.",
    canal: "Olá! Acessei o site do Dr. Gabriel Riccio e preciso de um tratamento de canal. Gostaria de obter informações.",
    endoDelivery:
        "Olá! Sou profissional da área odontológica e gostaria de saber mais sobre o serviço de Endo Delivery.",
};

export const waTratamento = (nome) =>
    wa(
        `Olá! Acessei o site do Dr. Gabriel Riccio e gostaria de informações sobre ${nome}.`,
    );

export const PHONE_DISPLAY = "(13) 99788-1908";
export const ADDRESS_SHORT = "Rua Dr. Bias Bueno, 18 — Boqueirão, Santos — SP";
export const ADDRESS_FULL =
    "Rua Dr. Bias Bueno, 18 — Boqueirão, Santos — SP, CEP 11045-070";

export const MAPS_DIRECTIONS = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    "Rua Bias Bueno, 18, Boqueirão, Santos - SP, 11045-070",
)}`;

export const MAPS_EMBED = `https://www.google.com/maps?q=${encodeURIComponent(
    "Rua Bias Bueno, 18, Boqueirão, Santos - SP",
)}&output=embed`;

export const NAV_LINKS = [
    { label: "Início", href: "#inicio" },
    { label: "Sobre", href: "#sobre" },
    { label: "Tratamentos", href: "#tratamentos" },
    { label: "Diferenciais", href: "#diferenciais" },
    { label: "Depoimentos", href: "#depoimentos" },
    { label: "Localização", href: "#localizacao" },
];
